import {
  EProductKind,
  IMenuCategorySectionProps,
  IProduct,
} from '@orderingstack/ordering-types';
import flatten from 'lodash/flatten';
import { ProductTile as DefaultMenuTile } from './ProductTile';
import React, { useState } from 'react';
interface Badge {
  id: string;
  label?: string;
  firstItemId?: string;
}

function CategorySection({
  category,
  onProductClicked,
  fallbackImg,
  lazyLoadImg,
  currency,
  cols,
  colsLg,
  MenuTile,
}: IMenuCategorySectionProps) {
  const Tile = MenuTile || DefaultMenuTile;
  const badges: Badge[] = [];
  category.items?.forEach((item) => {
    if (item.kind === EProductKind.CATEGORY) {
      badges.push({
        id: item.id,
        label: item.details?.literals?.name,
        firstItemId: item.items?.[0]?.id,
      });
    }
  });

  const [selectedBadge, setSelectedBadge] = useState<string | null>(
    badges[0]?.id
  );
  function onBadgeClicked(badge: Badge) {
    const productElem = document.getElementById(`product-${badge.firstItemId}`);
    productElem?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setSelectedBadge(badge.id);
  }

  return (
    <div
      id={`category-${category.id}`}
      key={category.id}
      className="flex flex-col p-4 px-6 pb-0 mt-4 h-full bg-bgColor lg:!mt-0"
    >
      <div id={`category-name-${category.id}`} className="mb-12 text-5xl">
        {category.details?.literals?.name}
      </div>
      {badges.length > 0 && (
        <div className="flex flex-row mb-[36px] space-x-2 text-xl">
          {badges.map((badge) => (
            <button
              className={`bg-bgColor-btnSecondary rounded-full px-6 py-2 text-fontColor-btnSecondary ${
                badge.id === selectedBadge
                  ? '!bg-primary !text-fontColor-bgPrimary'
                  : ''
              }`}
              key={badge.id}
              onClick={() => onBadgeClicked(badge)}
            >
              {badge.label}
            </button>
          ))}
        </div>
      )}
      <div className="overflow-x-hidden overflow-y-auto h-full">
        <div
          className={`grid ${cols ? `grid-cols-${cols}` : 'grid-cols-2'} ${
            colsLg ? ` lg:grid-cols-${colsLg}` : ' lg:grid-cols-4'
          } gap-4 lg:gap-6 lg:!gap-y-[36px]`}
        >
          {category.items?.map((categoryItem) => {
            let products: IProduct[];
            if (
              categoryItem.kind === EProductKind.PRODUCT ||
              categoryItem.kind === EProductKind.STATIC
            ) {
              products = [categoryItem];
            } else {
              products = flatten(categoryItem.items);
            }
            return products
              .filter(
                (x) =>
                  x.kind === EProductKind.PRODUCT ||
                  x.kind === EProductKind.STATIC
              )
              .map((IProduct, index) => {
                return (
                  <Tile
                    key={IProduct.details?.literals?.name || index}
                    product={IProduct}
                    onProductClicked={onProductClicked}
                    fallbackImg={fallbackImg}
                    lazyLoadImg={lazyLoadImg}
                    currency={currency}
                  />
                );
              });
          })}
        </div>
      </div>
    </div>
  );
}

export default CategorySection;
